import { Component } from "preact";
import CMSComponent from "../../components/CMSComponent";
import ContentBlock from "../../components/layout/ContentBlock";
import Layout from "../../components/layout/Layout";
import { updateTitle } from "../../utils/BrowserUtils";
import Features from "./components/Features";
import FeaturesAndPricingBanner from "./components/FeaturesAndPricingBanner";
import SeeOurProjects from "./components/SeeOurProjects";
import SpeakToHumans from "./components/SpeakToHumans";
import WorldClassFeatures from "./components/WorldClassFeatures";
import BookASession from "./components/BookASession";
import Plans from "./components/Plans";
import queryString from "query-string";
import GetInTouch from "./components/GetInTouch";

const getFeatureIcon = asset =>
  require(`../../assets/FeaturesAndPricing/featureIcons/${asset}`);
const getEventIcon = asset =>
  require(`../../assets/FeaturesAndPricing/eventTypeIcons/${asset}`);

const featureObj = [
  {
    title: "Design your event with Canva",
    text:
      "Make your event beautiful with Canva’s design tools right in our event builder.",
    icon: getFeatureIcon("ic_canva.svg")
  },
  {
    title: "Millions of eyes on your event",
    text:
      "Be in the spotlight for the million+ ticket buyers who visit us each year.",
    icon: getFeatureIcon("ic_million_eyes.svg")
  },
  {
    title: "1-Click Ticket Manager™",
    text:
      "Guests can update their details without an account, which means less management for you.",
    icon: getFeatureIcon("ic_one_click.svg")
  },
  {
    title: "Live impact tracking",
    text:
      "See the change your event is making in the world, and instantly publish your impact to social media.",
    icon: getFeatureIcon("ic_tracking.svg")
  },
  {
    title: "World-first accessibility features ",
    text:
      "Our unique accessibility features make guests with special needs feel welcome. ",
    icon: getFeatureIcon("ic_accessibility_feature.svg")
  },
  {
    title: "Complex tickets made simple",
    text:
      "Manage capacity or offer crazy combinations. Our tools make it simple.",
    icon: getFeatureIcon("ic_complex_tickets.svg")
  }
];

const topicsObj = [
  {
    img: getEventIcon("ic_festivals.svg"),
    alt: "festival icon",
    text: "Festival"
  },
  {
    img: getEventIcon("ic_conferences.svg"),
    alt: "conference icon",
    text: "Conference"
  },
  {
    img: getEventIcon("ic_live_events.svg"),
    alt: "live events icon",
    text: "Live events"
  },
  {
    img: getEventIcon("ic_schools.svg"),
    alt: "school icon",
    text: "Schools"
  },
  {
    img: getEventIcon("ic_charity.svg"),
    alt: "charity icon",
    text: "Charity"
  },
  {
    img: getEventIcon("ic_government.svg"),
    alt: "government icon",
    text: "Government"
  }
];

class FeaturesAndPricing extends Component {
  constructor(props) {
    super(props);
    const search = typeof window !== "undefined" ? window.location.search : "";
    const parsed = queryString.parse(search);
    let defaultTab = 1;
    if (parsed.tab) {
      switch (parsed.tab) {
        case "not-for-profit":
          defaultTab = 0;
          break;
        case "premium":
          defaultTab = 2;
          break;
      }
    }
    this.state = {
      defaultTab
    };
  }

  componentDidMount() {
    updateTitle("Features & Pricing");
  }

  render() {
    const { defaultTab } = this.state;

    return (
      <Layout>
        <FeaturesAndPricingBanner />
        <ContentBlock>
          <Features featureObj={featureObj} />
        </ContentBlock>
        <ContentBlock color="grey">
          <SpeakToHumans />
        </ContentBlock>
        <ContentBlock>
          {/* Disabled until we have pages to link to */}
          {/* ContentBlock left to create white space */}
          {/* <WorldClassFeatures topicsObj={topicsObj} /> */}
        </ContentBlock>
        <ContentBlock color="grey">
          <Plans defaultTab={defaultTab} />
          <GetInTouch locale={this.props.locale} />
        </ContentBlock>
        <SeeOurProjects />
        <BookASession />
      </Layout>
    );
  }
}

export default CMSComponent(null, FeaturesAndPricing);
